<template>
  <div>
    <!-- <Appbar elevation="2" :avatar="true" /> -->

    <router-view></router-view>

    <!-- <BottomNavigation /> -->
  </div>
</template>

<script>
// import BottomNavigation from "@/components/BottomNavigation.vue";

export default {
  
};
</script>